import { render, staticRenderFns } from "./RoutingForm.vue?vue&type=template&id=64ce4ee5&lang=pug&"
import script from "./RoutingForm.vue?vue&type=script&lang=ts&"
export * from "./RoutingForm.vue?vue&type=script&lang=ts&"
import style0 from "./RoutingForm.vue?vue&type=style&index=0&id=64ce4ee5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports